module.exports = __webpack_public_path__ + "static/media/Pool2.dfbb29df.jpg";